<div class="container pt-5">
    <div class="sub-txt-big text-start font-18 pt-1 pb-5">
        <div class="text-center py-3">
            <i class="fa fa-check-circle-o color-purple font-50" aria-hidden="true"></i>
        </div>
        <h2 class="text-center">Thank you for taking time to complete the questionnaire.</h2>
        <br>
        <p class="text-center">We’ve got it from here! Your advisor will follow up soon.</p>
        <br>
        <p class="text-center">If you have any questions, please contact us.</p>
    </div>
    <p class="small-border mx-auto"></p>
</div>